import * as React from "react";
import { ClampedContent } from "./ClampedContent";
import type { AnalysisParagraphResult } from "../../agreement";

export type AnalysisViewProps = {
  row: AnalysisParagraphResult;
};

export const AnalysisView: React.FC<AnalysisViewProps> = ({ row }) => {
  const text = row.analysis?.trim() ?? "";

  return (
    <div className="ai-analysis__content ai-analysis__content--analysis-only">
      <div className="ai-analysis__content-body">
        {text ? (
          <ClampedContent>
            <span>{text}</span>
          </ClampedContent>
        ) : (
          <span className="ai-analysis__muted">No analysis available.</span>
        )}
      </div>
    </div>
  );
};
